export default __webpack_public_path__ + "static/media/888-logo-white.908fbea9.svg";